import { render, staticRenderFns } from "./MenuTools.vue?vue&type=template&id=13cf2f99&scoped=true&"
import script from "./MenuTools.vue?vue&type=script&lang=js&"
export * from "./MenuTools.vue?vue&type=script&lang=js&"
import style0 from "./MenuTools.vue?vue&type=style&index=0&id=13cf2f99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf2f99",
  null
  
)

export default component.exports